import React from 'react';
export default function TopNineIcon({size=48}) {
 return <svg width={size} height={size} viewBox="0 0 48 48" aria-hidden="true" focusable="false"><rect x="3" y="3" width="42" height="42" rx="1" fill="white"/><rect x="17" y="17" width="14" height="14" fill="#a34eac"/><path d="M3 3H45V45H3ZM17 3V45M31 3V45M3 17H45M3 31H45" fill="none" stroke="#28222d" strokeWidth="2"/></svg>;
}
